import { render, staticRenderFns } from "./DeviceTypeList.vue?vue&type=template&id=44097436&"
import script from "./DeviceTypeList.vue?vue&type=script&lang=js&"
export * from "./DeviceTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports